import * as React from 'react'
import { Provider } from 'react-redux'
import { ThemeProvider } from '@emotion/react'
import { StyledEngineProvider } from '@mui/material/styles'
import { LicenseInfo } from '@mui/x-license'
import { StatsigProvider } from '@statsig/react-bindings'
import 'intersection-observer'
import * as ReactDOM from 'react-dom/client'
import { PersistGate } from 'redux-persist/integration/react'

import { IS_PROD, IS_STAGING } from '~config'

import App from './App'
import './components/styles/global.less'
import './components/styles/material-symbols.css'
import { lightTheme } from './createTheme'
import { persistor, store } from './redux/store'
import { statsigClient } from './statsigClient'

LicenseInfo.setLicenseKey(
  'c9e7181507b00c8ed84ccbfaecae7641Tz0xMjQ2MDUsRT0xODAwNjYyMzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MSxBVD1tdWx0aSxLVj0y',
)

// Don't auto-initialize analytics on embed paths - they initialize manually when engaged
const isEmbedPath =
  window.location.pathname.includes('/chat') ||
  window.location.pathname.includes('/search') ||
  window.location.pathname.includes('/query')

if (IS_PROD || IS_STAGING) {
  if (!isEmbedPath) {
    import('./SentryInit')
    import('./AmplitudeInit').then(({ initAmplitude }) => initAmplitude())
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={lightTheme}>
            {statsigClient ? (
              <StatsigProvider client={statsigClient}>
                <App />
              </StatsigProvider>
            ) : (
              <App />
            )}
          </ThemeProvider>
        </StyledEngineProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
)
